import DestinationPage from '@/components/DestinationPage';

const IleDeRe = () => {
  const villages = [
    { name: 'Rivedoux-Plage', path: '/destinations/ile-de-re/rivedoux-plage' },
    { name: 'Sainte-Marie-de-Ré', path: '/destinations/ile-de-re/sainte-marie-de-re' },
    { name: 'La Flotte', path: '/destinations/ile-de-re/la-flotte' },
    { name: 'Saint-Martin-de-Ré', path: '/destinations/ile-de-re/saint-martin-de-re' },
    { name: 'Le Bois-Plage-en-Ré', path: '/destinations/ile-de-re/le-bois-plage-en-re' },
    { name: 'La Couarde-sur-Mer', path: '/destinations/ile-de-re/la-couarde-sur-mer' },
    { name: 'Loix', path: '/destinations/ile-de-re/loix' },
    { name: 'Ars-en-Ré', path: '/destinations/ile-de-re/ars-en-re' },
    { name: 'Saint-Clément-des-Baleines', path: '/destinations/ile-de-re/saint-clement-des-baleines' },
    { name: 'Les Portes-en-Ré', path: '/destinations/ile-de-re/les-portes-en-re' }
  ];

  return (
    <DestinationPage
      title="Location de vélos à l'Île de Ré"
      subtitle="Découvrez l'île de Ré à vélo : 110 km de pistes cyclables entre plages, villages et marais salants"
      description="L'Île de Ré est la destination vélo par excellence. Avec plus de 110 km de pistes cyclables sécurisées, l'île offre un terrain de jeu idéal pour les cyclistes de tous niveaux. Parcourez les villages blancs aux volets verts, longez les plages de sable fin, traversez les marais salants et découvrez les ports pittoresques."
      highlights={[
        "110 km de pistes cyclables sécurisées",
        "10 villages authentiques à découvrir",
        "Plages de sable fin accessibles à vélo",
        "Marais salants et patrimoine naturel",
        "Ports de pêche et marchés locaux",
        "Itinéraires adaptés à tous les niveaux"
      ]}
      villages={villages}
    />
  );
};

export default IleDeRe;